export enum ProgressStatuses {
  NOT_STARTED = 'not_started',
  IN_PROCESS = 'in_process',
  PASSED = 'passed',
}
